module.exports = __webpack_public_path__ + "static/purchase-40509f486a847e2d123b133bd62b1ebf.mp4";